import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';

export interface TableCellCopyParams extends ICellRendererParams {
    /** Friendly label shown in the growler title, e.g. "IP Address" */
    label?: string;
}

@Component({
    selector: 'app-table-cell-copy',
    templateUrl: './table-cell-copy.component.html',
    styleUrls: ['./table-cell-copy.component.scss'],
    standalone: false,
})
export class TableCellCopyComponent implements ICellRendererAngularComp {
    value = '';
    label = 'Value';

    constructor(private growlerService: GrowlerService) {}

    agInit(params: TableCellCopyParams): void {
        this.setFromParams(params);
    }

    refresh(params: TableCellCopyParams): boolean {
        this.setFromParams(params);
        return true;
    }

    copy(event: MouseEvent): void {
        event?.stopPropagation();
        if (!this.value) {
            return;
        }
        navigator.clipboard.writeText(this.value);
        this.growlerService.show(
            new GrowlerData(
                'success',
                'Success',
                `${this.label} Copied`,
                `The ${this.label.toLowerCase()} has been copied to your clipboard`
            )
        );
    }

    private setFromParams(params: TableCellCopyParams): void {
        this.label = params?.label || 'Value';
        const raw = params?.valueFormatted ?? params?.value;
        this.value = raw == null ? '' : String(raw);
    }
}
